module.exports = __webpack_public_path__ + "static/media/shuttle-van.37d60c9e.svg";